var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 26.8125L4.875 31.59V17.875H9.75M17.875 23.8225L15.3238 21.645L13 23.79V11.375H17.875M26 21.125L21.125 26V4.875H26M30.5662 20.8163L27.625 17.875H35.75V26L32.8412 23.0912L21.125 34.71L15.4862 29.8025L9.34375 35.75H4.875L15.3888 25.4475L21.125 30.29",
    fill: "#054139"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFour);
export default __webpack_public_path__ + "static/media/four.cdc9b09deea06d2b8103d607c950d6c3.svg";
export { ForwardRef as ReactComponent };